import { useConnectionStore } from '@/stores/connectionStore';

export function OfflineBanner() {
  const online = useConnectionStore((s) => s.online);
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="pt-2-safe bg-brand-warn text-brand-textDark text-center text-sm font-semibold px-3 pb-2"
    >
      You are offline. Activity will sync automatically when you reconnect.
    </div>
  );
}
